import { travelGuideQueryKeys as e } from "./travelGuideQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { travelGuidesApi as r } from "@maat/api-main";
//#region src/travelGuides/useGuidePlaceMutations.ts
var i = (i) => {
	let a = n();
	return t({
		mutationFn: ({ sectionId: e, data: t }) => r.createPlace(i, e, t),
		onSuccess: () => a.invalidateQueries({ queryKey: e.detail(i) })
	});
}, a = (i) => {
	let a = n();
	return t({
		mutationFn: ({ sectionId: e, placeId: t, data: n }) => r.updatePlace(i, e, t, n),
		onSuccess: () => a.invalidateQueries({ queryKey: e.detail(i) })
	});
}, o = (i) => {
	let a = n();
	return t({
		mutationFn: ({ sectionId: e, placeId: t }) => r.deletePlace(i, e, t),
		onSuccess: () => a.invalidateQueries({ queryKey: e.detail(i) })
	});
}, s = (i) => {
	let a = n();
	return t({
		mutationFn: ({ sectionId: e, ids: t }) => r.reorderPlaces(i, e, t),
		onSuccess: () => a.invalidateQueries({ queryKey: e.detail(i) })
	});
}, c = (i) => {
	let a = n();
	return t({
		mutationFn: ({ sectionId: e, placeId: t, file: n }) => r.uploadPlaceImage(i, e, t, n),
		onSuccess: () => a.invalidateQueries({ queryKey: e.detail(i) })
	});
};
//#endregion
export { i as useCreateGuidePlaceMutation, o as useDeleteGuidePlaceMutation, s as useReorderGuidePlacesMutation, a as useUpdateGuidePlaceMutation, c as useUploadGuidePlaceImageMutation };
